export default {
  LEFT: 'left',
  RIGHT: 'right',
  BOTH: 'both',
};
